import { render, staticRenderFns } from "./ColorPickerButton.vue?vue&type=template&id=6d6e4206&scoped=true"
import script from "./ColorPickerButton.vue?vue&type=script&lang=js"
export * from "./ColorPickerButton.vue?vue&type=script&lang=js"
import style0 from "./ColorPickerButton.vue?vue&type=style&index=0&id=6d6e4206&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d6e4206",
  null
  
)

export default component.exports